import StaffTypeList from "./staffTypeList/SaffTypeList"

function StaffType() {
    return (
        <>
            <StaffTypeList />
        </>
    )
}
export default StaffType